module.exports = __webpack_public_path__ + "static/media/sort_both.fb216db0.png";